import React, { useState } from "react";
import ImageInstruction from "../../images/img-instruction.gif";
import EmotiiInstructions from "../../images/emotii-instructions.png";

import useFooter from "../../hooks/useFooter";
import BrandingFooter from "../Footer/BrandingFooter";
import {
  incrementCurrentSlide,
  incrementPeekSlide,
} from "../../store/slices/slides";
import { useDispatch } from "react-redux";
import classNames from "classnames";

function InstructionSlide({ isVisible }) {
  const dispatch = useDispatch();
  useFooter(isVisible, <BrandingFooter />);

  return (
    <div className="h-full bg-emotii-instruction">
      <div class="block-emotti">
        <div class="block-welcome">
          <img src={EmotiiInstructions} alt="" class="emotii-ttl" />

          <div class="text-right">
            <h1 class="">Instructions </h1>
          </div>

          <div class="flex w-full flex-wrap">
            <p class="text-base leading-[22px]  w-full ">
              For each question, move your cursor along the slider until the
              Emotii image most closely matches how you have been feeling over
              the last two weeks, <u>including today</u>.
            </p>

            <img
              src={ImageInstruction}
              alt=""
              class="place-self-start w-full max-w-[230px] m-auto mt-6"
            />
          </div>

          <div class="btn-box-introduction small-btn text-right ">
            <a
              class="next btn btn-white"
              href="#"
              onClick={() => {
                dispatch(incrementCurrentSlide());
                dispatch(incrementPeekSlide());
              }}
            >
              Get Started
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default InstructionSlide;
